export default {
    alert: false,
    success: false,
    mensaje: "",
    mostrar: false,
    color: "",
    timeout: null
}